enableListRequestType=[{
	requestTypeEnable:'1',valueEnable: 'Đang hoạt động'
},{
	requestTypeEnable:'0',valueEnable: 'Ngừng hoạt động'
}];
